// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';

import baseTheme from '../../trellis/light/theme';

export type ThemeName = 'navy';

export type ThemeMode = 'light';

/**
 * Design System theme object.
 *
 * Theme name: `navy`
 *
 * Theme mode: `light`
 */
const theme = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    'fwc-button-fill-primary-default': '#e74100',
  },
};

Object.assign(theme, {
  [THEME_NAME]: 'navy',
  [THEME_MODE]: 'light',
});

export default theme;
